export default "__VITE_ASSET__BDV4jTHM__"